// test1059
(1059 && 0);
